import type { InvoicesOverviewsAdditionalFilter } from '@weft/api-definition';
import type { InvoiceBillingStatus, InvoiceDate, InvoiceReviewStatus } from '@weft/types';
import { isNotEmptyArray } from '@weft/utils';
import { usePageParam } from '../../../../hooks/search-params/use-page-param';
import { usePageSizeParam } from '../../../../hooks/search-params/use-page-size-param';
import { useSelectedAdditionalFilters } from './use-additional-filters';
import { useDatesParam } from './use-months-param';
import { useQueryInputParams } from './use-query-input-param';
import { useSelectedBillingStatusesParam } from './use-selected-billing-statuses-param';
import { useSelectedWorkflowsParam } from './use-selected-workflows-param';

type UseInvoicesPageParams = {
  dates?: InvoiceDate[] | undefined;
  selectedBillingStatuses?: InvoiceBillingStatus[] | undefined;
  selectedWorkflows?: InvoiceReviewStatus[] | undefined;
  search?: string;
  page?: number;
  pageSize?: number;
  selectedAdditionalFilters?: InvoicesOverviewsAdditionalFilter[];
};

export function useInvoicesPageParams(): UseInvoicesPageParams {
  const [dates] = useDatesParam();
  const [selectedBillingStatuses] = useSelectedBillingStatusesParam();
  const [selectedWorkflows] = useSelectedWorkflowsParam();
  const [search] = useQueryInputParams();
  const [page] = usePageParam();
  const [pageSize] = usePageSizeParam(50);
  const [selectedAdditionalFilters] = useSelectedAdditionalFilters();

  return {
    dates: dates ?? undefined,
    selectedBillingStatuses: isNotEmptyArray(selectedBillingStatuses) ? selectedBillingStatuses : undefined,
    selectedWorkflows: isNotEmptyArray(selectedWorkflows) ? selectedWorkflows : undefined,
    search: search ?? undefined,
    page: page ?? undefined,
    pageSize: pageSize ?? undefined,
    selectedAdditionalFilters: isNotEmptyArray(selectedAdditionalFilters) ? selectedAdditionalFilters : undefined,
  };
}